// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"video__iframeContainer___3sbpx","iframe":"video__iframe___1V_AU","invalidVideoSrc":"video__invalidVideoSrc___2p2Pl"};